import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        width: "67.39vw",
        height: "33.33vw",
        margin: "auto auto 4.83vw auto",
        backgroundColor: Color.DeepBlack
    },
    desktop: {
        width: "17.18vw",
        height: "9.68vw",
        margin: "auto auto 1.04vw auto",
        backgroundColor: Color.DeepBlack 
    }
};

export const QuatoDetailsLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;
    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }

    return (
        <div style={loaderStyles}>
            <ContentLoader
                speed={1}
                backgroundColor={Color.DeepBlack}
                foregroundColor={Color.LoaderForeground}
                width= "auto"
                height= {loaderStyles.height}
            > 
                {isMobile ? <>
                    <rect x="5.3%" y="14.4%" rx="3" ry="3" width="22.9%" height="23.1%" />
                    <rect x="69.5%" y="14.4%" rx="3" ry="3" width="25%" height="14.4%" />
                    <rect x="5.3%" y="44.9%" rx="3" ry="3" width="89.2%" height="13%" />
                    <rect x="5.3%" y="77.5%" rx="3" ry="3" width="29.7%" height="13%" />
                    <rect x="39.7%" y="67.5%" rx="8" ry="8" width="54.8%" height="28.8%" />
                </> : 
                <>
                    <rect x="6.06%" y="14.5%" rx="3" ry="3" width="28.1%" height="20.4%" />
                    <rect x="65.7%" y="14.5%" rx="3" ry="3" width="23%" height="14.5%" />
                    <rect x="6.06%" y="41.3%" rx="3" ry="3" width="87.8%" height="13.4%" />
                    <rect x="6.06%" y="76.8%" rx="3" ry="3" width="31.2%" height="12.3%" />
                    <rect x="42.7%" y="76.8%" rx="8" ry="8" width="55.7%" height="21.5%" />
                </>} 
            </ContentLoader>
        </div>
    );
}